import { CartProduct } from "../utils/cartTypes";
import { $cartStore } from "../utils/store";
import { useStore } from "@nanostores/react";
import { __t } from "../utils/translate";

type UseCartData = () => {
    isCartEmpty: boolean;
    subtotal: number;
    total: number;
    roundedPercentage: number;
    couponCode: string;
    shipping: string | number;
    products: CartProduct[];
} | null;

export const useCartData: UseCartData = () => {
    let cart = useStore($cartStore);

    if (typeof cart !== 'object') {
        cart = null;
    }

    const isCartEmpty = !cart?.cart || cart.cart.length === 0;

    const subtotal = cart?.stripe_cart?.order_data.displayItems.subtotal?.amount || 0;
    const total = cart?.stripe_cart?.order_data.total.amount || 0;
    const shipping =
        cart?.stripe_cart?.order_data.displayItems.shipping?.amount || __t("Free");
    const products = typeof cart?.cart === 'object' ? Array.from(Object.values(cart.cart)) : [];
    const couponCode = cart?.applied_coupons?.length ? Object.values(cart.applied_coupons)[0] : null;
    const percentage = (((subtotal - total) / total) * 100);
    const roundedPercentage = Math.floor(percentage / 5) * 5;

    return { isCartEmpty, subtotal, total, shipping, products, couponCode, roundedPercentage };
};
